import { AdviseEngagement, AdviseSupplier, MatrixFeature } from '../../../../types/advise';
import { FeatureComparisonRow } from './types';
import { featureNote } from '../../../../utils/adviseMatrix';

/** One row per selected feature, saying which suppliers support it, with the feature's note in each. */
export const buildFeatureComparison = (
  features: MatrixFeature[],
  suppliers: AdviseSupplier[],
  featureNotes: AdviseEngagement['feature_notes'] | undefined
): FeatureComparisonRow[] =>
  features.map((feature) => {
    const row: FeatureComparisonRow = { feature: feature.label };
    const note = featureNote(featureNotes, feature);
    suppliers.forEach((supplier) => {
      const supported = supplier.supported_features?.includes(feature.key) || false;
      row[supplier.id] = { supported, note };
    });
    return row;
  });
